import script from "./ValueProps.vue?vue&type=script&setup=true&lang=js"
export * from "./ValueProps.vue?vue&type=script&setup=true&lang=js"

import "./ValueProps.vue?vue&type=style&index=0&id=1df27adf&scoped=true&lang=css"

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df27adf"]])

export default __exports__